export var CommunicationDisplayStatus = /*#__PURE__*/function (CommunicationDisplayStatus) {
  CommunicationDisplayStatus["WaitingOnClient"] = "WaitingOnClient";
  CommunicationDisplayStatus["Sent"] = "Sent";
  CommunicationDisplayStatus["Completed"] = "Completed";
  CommunicationDisplayStatus["Rejected"] = "Rejected";
  CommunicationDisplayStatus["Canceled"] = "Canceled";
  CommunicationDisplayStatus["Received"] = "Received";
  return CommunicationDisplayStatus;
}({});
